import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LandingPage from '../landing-page';
import { useAuthModal } from '../../contexts/AuthModalContext';

const RegisterPage = () => {
  const location = useLocation();
  const { openAuthModal } = useAuthModal();

  useEffect(() => {
    openAuthModal('register', {
      redirectTo: location.state?.from || location.state?.redirect || '/interview-setup',
    });
  }, [location.state, openAuthModal]);

  return <LandingPage />;
};

export default RegisterPage;
